import React, { createContext, useContext, useEffect, useState } from 'react';
import { LOCAL_STORAGE_INVOICES_KEY, LOCAL_STORAGE_PURCHASE_ORDERS_KEY } from '../utils/constants';

export const TransactionContext = createContext(null);

export function useTransaction() {
  return useContext(TransactionContext);
}

export function TransactionProvider({ children }) {
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [invoices, setInvoices] = useState([]);

  // Load from Local Storage on mount
  useEffect(() => {
    const invoices = JSON.parse(localStorage.getItem(LOCAL_STORAGE_INVOICES_KEY)) || [];
    const purchaseOrders = JSON.parse(localStorage.getItem(LOCAL_STORAGE_PURCHASE_ORDERS_KEY)) || [];
    if (invoices && invoices?.length > 0) {
        setInvoices(invoices);
        // console.log('data', data)
        // if(data.purchaseOrders && data.purchaseOrders?.length > 0)
        //     setPurchaseOrders(data.purchaseOrders || []);

        // if(data.invoices && data.invoices?.length > 0)
        //     setInvoices(data.invoices || []);
    }
    if (purchaseOrders && purchaseOrders?.length > 0) {
        setPurchaseOrders(purchaseOrders);
        // console.log('data', data)
        // if(data.purchaseOrders && data.purchaseOrders?.length > 0)
        //     setPurchaseOrders(data.purchaseOrders || []);

        // if(data.invoices && data.invoices?.length > 0)
        //     setInvoices(data.invoices || []);
    }
  }, []);

  useEffect(() => {
    if(invoices && invoices?.length > 0)
        localStorage.setItem(LOCAL_STORAGE_INVOICES_KEY, JSON.stringify(invoices));

    if(purchaseOrders && purchaseOrders?.length > 0)
        localStorage.setItem(LOCAL_STORAGE_PURCHASE_ORDERS_KEY, JSON.stringify(purchaseOrders));

  }, [purchaseOrders, invoices]);

  const addPurchaseOrder = (po) => setPurchaseOrders((prev) => [...prev, po]);
  const addInvoice = (invoice) => setInvoices((prev) => [...prev, invoice]);

  const clearAllTransactions = () => {
    setPurchaseOrders([]);
    setInvoices([]);
  };

  return (
    <TransactionContext.Provider
      value={{
        purchaseOrders,
        invoices,
        addPurchaseOrder,
        addInvoice,
        clearAllTransactions,
      }}
    >
      {children}
    </TransactionContext.Provider>
  );
}
